










































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import FieldHolder from "@/form/FieldHolder.vue";
import ErrorList from "@/components/ErrorList.vue";
import { CommonField } from "@/form/CommonField";

@Component({
	components: {
		FieldHolder,
		ErrorList,
	},
})
export default class CheckBox extends Vue implements CommonField {
	private static uniqueId = 0;

	/**
	 * id must be globally unique in a HTML document, we guarantee this by making each render
	 * of this component have unique ID number appended to the end to avoid clashes.
	 *
	 * We need ids mostly to connect <label> and <input> elements together for accessibility.
	 */
	readonly id = "CheckBox_" + ++CheckBox.uniqueId;

	@Prop([String]) readonly name!: string;

	@Prop([String]) readonly label!: string;

	@Prop(Boolean) readonly value!: boolean;

	@Prop([String, Object]) readonly rules!: string | object;

	@Prop(Boolean) readonly readonly!: boolean;

	@Prop(Boolean) readonly disabled!: boolean;

	/**
	 * Add additional custom error messages to this field.
	 */
	@Prop([Array]) readonly errors!: string[];

	/**
	 * Whether errors are shown externally.
	 */
	@Prop(Boolean) readonly errorsShownExternally!: boolean;

	@Prop(String) readonly placeholder!: string;

	@Prop({ type: Boolean, default: false }) switchMode!: boolean;

	onChecked(e: any) {
		this.$emit("input", e);
	}

	get isChecked() {
		return this.value;
	}
}
